import ErrorAlert from '@/components/errorAlert';
import { routeTree } from '@/routeTree.gen';
import { createRouter } from '@tanstack/react-router';

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }

    interface HistoryState {
        validate?: boolean;
    }
}

const router = createRouter({
    routeTree,
    context: {
        loginState: 'pending' as 'pending' | 'loggedIn' | 'loggedOut',
    },
    defaultPreload: 'intent',
    defaultErrorComponent: ErrorAlert,

    scrollRestoration: true,
    getScrollRestorationKey(location) {
        if (['/'].includes(location.pathname)) {
            return location.pathname;
        }

        return location.state.__TSR_key!;
    },
});

export default router;
